module.exports = __webpack_public_path__ + "static/media/logo.81324617.svg";